export const CWY_MIN_REQUEST_AMOUNT = 1;
export const CWY_DECIMALS = 9;

const AMOUNT_PATTERN = /^\d+(\.\d+)?$/;

export function validateCwyRequestAmount(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) {
    return 'Enter an amount';
  }
  if (!AMOUNT_PATTERN.test(trimmed)) {
    return 'Enter a valid number';
  }
  const [, fraction = ''] = trimmed.split('.');
  if (fraction.length > CWY_DECIMALS) {
    return `Up to ${CWY_DECIMALS} decimal places`;
  }
  const amount = Number(trimmed);
  if (!Number.isFinite(amount) || amount < CWY_MIN_REQUEST_AMOUNT) {
    return `Minimum amount is ${CWY_MIN_REQUEST_AMOUNT} CWY`;
  }
  return null;
}

export function parseCwyRequestAmount(input: string): number {
  const error = validateCwyRequestAmount(input);
  if (error) {
    throw new Error(error);
  }
  return Number(input.trim());
}
